<template>
  <div class="field-preview">
    <div class="field-label">
      <span>{{ field.label }}</span>
      <v-chip x-small color="primary" class="ml-2" v-if="field.required">Required</v-chip>
    </div>

    <v-textarea
      v-model="value"
      :placeholder="field.hint || 'Enter text here...'"
      outlined
      no-resize
      rows="3"
      :rules="fieldRules"
      counter
      :maxlength="maxLength"
      class="preview-input"
    ></v-textarea>

    <div class="field-description" v-if="field.description">
      <v-icon small color="grey">mdi-information-outline</v-icon>
      <span>{{ field.description }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextareaFieldPreview',
  props: {
    field: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      value: ''
    }
  },
  computed: {
    minLength() {
      return this.field.minLength;
    },
    maxLength() {
      return this.field.maxLength;
    },
    fieldRules() {
      const rules = [];

      // Required validation
      if (this.field.required) {
        rules.push(v => !!v || 'This field is required');
      }

      // Min length validation
      if (this.minLength !== undefined) {
        rules.push(v => !v || v.length >= this.minLength || `Minimum length is ${this.minLength} characters`);
      }

      // Max length validation
      if (this.maxLength !== undefined) {
        rules.push(v => !v || v.length <= this.maxLength || `Maximum length is ${this.maxLength} characters`);
      }

      return rules;
    }
  }
}
</script>

<style scoped>
.field-preview {
  display: flex;
  flex-direction: column;
}

.field-label {
  font-weight: 500;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}

.field-description {
  margin-top: 4px;
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  gap: 4px;
}

.preview-input {
  opacity: 0.9;
}

.preview-input :deep(.v-input__slot) {
  cursor: default;
  background-color: #f5f7fa !important;
}
</style>
